"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysOfTheWeek = void 0;
exports.daysOfTheWeek = [
    {
        id: 0,
        key: "sunday",
        day: "Sunday",
    },
    {
        id: 1,
        key: "monday",
        day: "Monday",
    },
    {
        id: 2,
        key: "tuesday",
        day: "Tuesday",
    },
    {
        id: 3,
        key: "wednesday",
        day: "Wednesday",
    },
    {
        id: 4,
        key: "thursday",
        day: "Thursday",
    },
    {
        id: 5,
        key: "friday",
        day: "Friday",
    },
    {
        id: 6,
        key: "saturday",
        day: "Saturday",
    },
    {
        id: 7,
        key: "public_holidays",
        day: "Public Holidays",
    },
];
// TODO: Add more constants here as needed.
